import { ChangeDetectorRef, Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DestroyableBase } from '../../utils';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnRerenderOnEvent]',
})
export class RerenderOnEventDirective<T = unknown> extends DestroyableBase implements OnDestroy {
  private subscription: Subscription;

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly templateRef: TemplateRef<any>,
    private readonly cdRef: ChangeDetectorRef
  ) {
    super();
  }

  @Input()
  // Input name must match directive selector, finish notation can't be used
  // eslint-disable-next-line rxjs/finnish
  set osnRerenderOnEvent(event$: Observable<T>) {
    this.clearSubscription();
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef);

    this.subscription = this.untilDestroy$(event$).subscribe(() => {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.cdRef.detectChanges();
    });
  }

  private clearSubscription() {
    this.subscription?.unsubscribe();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    this.clearSubscription();
  }
}
